<template>
  <div>
    <LoadingSpinner v-if="!completeLoading || loading" />
    <div v-else>
      <div class="bg-light pt-3 pb-2 mb-5">
        <div class="row border-bottom border-grey">
          <div class="col-sm-12">
            <div class="px-4 float-left">
              <div>
                <Tabs
                  :tabs="tabs"
                  @change="changeTab($event)"
                  :tabSelected="tabSelected"
                />
              </div>
            </div>
            <div class="top-area-opp float-right mt--5 mr-2">
              <button
                class="w-100 btn btn-sm btn-primary themed-button effect-btn"
                @click="openModalTemplate()"
                type="submit"
              >
                <i class="icon-plus1"></i>
                {{ $t("lang.button.addnewtemplate") }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <main class="">
        <div class="row">
          <div class="col-sm-12"></div>
          <div class="col-sm-12">
            <template v-for="template in templateTypes">
              <template v-for="part in parseInt(template.max_part)">
                <template
                  v-for="step in part == '2' ? 1 : parseInt(template.max_step)"
                >
                  <Fieldset
                    :key="template.id + part + step"
                    :titleHtml="
                      template.name +
                      (part == 1 ? ' Message' : ' Subject') +
                      ' ' +
                      (template.max_part == template.max_step || part == '2'
                        ? ''
                        : step) + (template.description ? `<span class='ml-3' style='color: black; font-weight: bold;'> ${$t('lang.label.description')}: ${template.description}</span>` : '')
                      "
                    :open="false"
                    :mykey="template.id * part * step * 100"
                    @opennow="openFildset(template.id, part, step)"
                    v-if="template.tab_id == tabSelected"
                  >
                    <CampaignStepTemplate
                      v-if="fieldsetIsOpen(template.id, part, step)"
                      :key="100"
                      :availableTokens="availableTokens.data"
                      :availableTokensSelect="availableTokensSelect"
                      :campaignStepTemplateTypeId="parseInt(template.id)"
                      :campaignStepTemplatePartId="part"
                      :step="step"
                      :currentUser="currentUser"
                    />
                  </Fieldset>
                </template>
              </template>
            </template>
          </div>
        </div>
      </main>
    </div>
    <Modal :name="'newTemplate'">
      <div class="p-4 text-center">
        <label>
          <h4>{{ $t("lang.template.add") }}</h4>
        </label>
      </div>
      <div class="px-4 pb-4">
        <vue-form-generator
          ref="templateForm"
          :schema="templateSchema"
          :model="templateModel"
          :options="formOptions"
        ></vue-form-generator>

        <div class="mt-4" v-if="alert.message">
          <AlertError :msgError="alert.message" />
        </div>

        <button
          class="float-right btn btn-primary mt-3"
          @click="saveTemplate"
          type="submit"
        >
          <i class="icon-plus1"></i> {{ $t("lang.button.save") }}
        </button>
      </div>
    </Modal>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import CampaignStepTemplate from "@/components/Account/CampaignStepTemplate.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import i18n from "@/_helpers/i18n";
import Fieldset from "@/components/Common/Fieldset.vue";
import { formattersMixin, campaignUtilsMixin } from "@/_mixins/";
import { adminService } from "@/_services";
import Tabs from "@/components/Common/Tabs.vue";
import Modal from "@/components/Common/Modal.vue";
import VueFormGenerator from "vue-form-generator";
import "vue-form-generator/dist/vfg.css";
import AlertError from "@/components/AlertError.vue";

export default {
  data() {
    var self = this;
    return {
      maxStep: undefined,
      currentStep: undefined,
      templateTypes: [],
      tabs: {
        1: {
          id: 1,
          name: this.$t("lang.menu.campaigns"),
        },
        2: {
          id: 2,
          name: this.$t("lang.label.autoreply"),
        },
        3: {
          id: 3,
          name: this.$t("lang.label.notifications"),
        },
      },
      tabSelected: 1,
      loading: true,
      availableTokensSelect: [],
      fieldsetStatus: {},
      templateModel: {},
      templateSchema: {
        fields: [
          {
            type: "input",
            inputType: "text",
            label: this.$t("lang.label.name"),
            model: "name",
            featured: true,
            required: true,
            min: 5,
            max: 255,
            validator: [
              VueFormGenerator.validators.string.locale({
                fieldIsRequired: this.$t("lang.label.required"),
              }),
            ],
            styleClasses: "col-md-6",
          },
          {
            type: "select",
            label: "Tab",
            model: "tab_id",
            featured: true,
            required: true,
            values: function () {
              return [
                { id: "1", name: this.$t("lang.menu.campaigns") },
                { id: "2", name: this.$t("lang.label.autoreply") },
                { id: "3", name: this.$t("lang.label.notifications") },
              ];
            },
            validator: VueFormGenerator.validators.required,
            styleClasses: "col-md-6 text-left",
          },
          {
            type: "textArea",
            inputType: "text",
            label: this.$t("lang.label.description"),
            model: "description",
            featured: true,
            required: true,
            rows: 4,
            visible() {
              return self.templateModel.tab_id === "3"
            },
            min: 5,
            max: 2000,
            validator: [
              VueFormGenerator.validators.string.locale({
                fieldIsRequired: this.$t("lang.label.required"),
              }),
            ],
            styleClasses: "col-md-12",
          },
          {
            type: "checkbox",
            model: "include_email_subject",
            featured: false,
            label: this.$t("lang.template.include_email_subject"),
            styleClasses: "col-md-6",
          },
        ],
      },
      formOptions: {
        validateAfterLoad: false,
        validateAfterChanged: true,
      },
    };
  },

  components: {
    CampaignStepTemplate,
    LoadingSpinner,
    Fieldset,
    Tabs,
    Modal,
    "vue-form-generator": VueFormGenerator.component,
    AlertError,
  },

  mixins: [formattersMixin, campaignUtilsMixin],

  computed: {
    ...mapState({
      currentUser: (state) => state.authentication.user,
      completeLoading: (state) => state.optionsList.completeLoadingTemplate,
      availableTokens: (state) => state.optionsList.all["available_tokens"],
      alert: (state) => state.alert,
    }),
  },

  created() {
    this.availableTokensSelect = this.availableTokens["data"]
      .map(function (element) {
        if (element.translated === undefined) {
          element.name = i18n.t("lang.token." + element.name);
          element.translated = true;
        }
        return element;
      })
      .filter((token) => token.token != "[my_proposition]")
      .filter((token) => token.token != "[my_website_url_tracking]")
      .filter((token) => this.filterTokens(token));

    this.getTypes();
  },

  methods: {
    ...mapActions("header", {
      changeHeaderTab: "changeTab",
    }),
    fieldsetIsOpen(type, part, step) {
      return this.fieldsetStatus["t" + type + "_p" + part + "_s" + step];
    },
    openFildset(type, part, step) {
      this.fieldsetStatus["t" + type + "_p" + part + "_s" + step] = true;
    },
    changeTab(id) {
      this.tabSelected = id;
    },
    openModalTemplate() {
      this.$store.dispatch("alert/clear");
      this.templateModel = {};
      this.templateModel.tab_id = this.tabSelected.toString()
      this.$modal.show("newTemplate");
    },
    saveTemplate() {
      this.$refs.templateForm.validate();
      // el mensaje aparece debajo del modal
      if (this.$refs.templateForm.errors.length > 0) {
        return false;
      }

      adminService.addCampaignStepTemplateTypes(this.templateModel).then(
        (result) => {
          this.$modal.hide("newTemplate");
          this.tabSelected = parseInt(this.templateModel.tab_id);
          this.getTypes();
        },
        (error) => {
          this.$store.dispatch("alert/error", error, { root: true });
        }
      );

      return true;
    },
    getTypes() {
      this.loading = true;
      adminService
        .getCampaignStepTemplateTypes()
        .then((result) => {
          this.templateTypes = result;

          this.templateTypes.forEach((template) => {
            let typeId = template.id;
            let maxPart = template.max_part;
            let maxStep = template.max_step;
            for (let part = 1; part <= maxPart; part++) {
              for (let step = 1; step <= maxStep; step++) {
                // this.fieldsetStatus["t" + typeId + "_p" + part + "_s" + step] = false;
                // dinamyc object - reactive
                this.$set(
                  this.fieldsetStatus,
                  "t" + typeId + "_p" + part + "_s" + step,
                  false
                );
              }
            }
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.datepicker {
  transform: translate(0, 3.1em);
}
</style>
